import React, { memo } from "react";
import PropTypes from "prop-types";

export const RenderForeignDivision = memo(({ value }) => {
  return value ? (
    <div
      style={{
        fontWeight: "bold",
        fontSize: "1.25em",
        border: "4px solid black",
        borderRadius: "20px",
        padding: "2px 2px",
      }}
    >
      Y
    </div>
  ) : (
    <div>N</div>
  );
});

RenderForeignDivision.displayName = "RenderForeignDivision";

RenderForeignDivision.propTypes = {
  value: PropTypes.string,
};
